import * as React from 'react';
import { connect } from 'react-redux';
import { CallbackComponent } from 'redux-oidc';
import userManager from '../../utils/userManager';
import { conf } from './../../constants/config/configVars';



class Callback extends React.Component<{},{}> {
  public render() {
    const redir = () => {
      window.location.href = conf.oidc_callback_redirect
    }
    return(
      <CallbackComponent userManager={userManager} successCallback={redir}>
        <div>
          Redirecting ....
        </div>
      </CallbackComponent>
    )
  }

}

export default connect()(Callback);



// WEBPACK FOOTER //
// ./src/Containers/oidc/Callback.tsx